import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

export type ScrollPositionInfo = {
  clientHeight: number;
  scrollHeight: number;
  scrollTop: number;
};

// https://stackoverflow.com/questions/51908241/when-trying-access-event-target-something-always-return-undefined

export default function useScroll(wait: number = 100) {
  const [positionInfo, setPositionInfo] = useState<ScrollPositionInfo>({
    clientHeight: document.body.clientHeight,
    scrollHeight: document.body.scrollHeight,
    scrollTop: document.body.scrollTop,
  });

  useEffect(() => {
    const handleScroll = throttle((e: any) => {
      const { clientHeight, scrollHeight, scrollTop } = document.documentElement || {};

      if (clientHeight !== undefined && scrollHeight !== undefined && scrollTop !== undefined) {
        setPositionInfo({
          clientHeight,
          scrollHeight,
          scrollTop,
        });
      }

      //console.log(e.target.scrollingElement);
    }, wait);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [window]);

  return { positionInfo };
}
